import { ALL_PRODUCT_TYPES } from "constants/chart.constants";
import { getProductType } from "utils";

import { EntityKind } from "models/entityKind";

export const checkProductExists = (product: string, entityKind: EntityKind): boolean => {
  if (
    getProductType(product, entityKind) ===
      (entityKind === EntityKind.Well
        ? ALL_PRODUCT_TYPES.Oil
        : ALL_PRODUCT_TYPES.GasInlet) &&
    product !==
      (entityKind === EntityKind.Well
        ? ALL_PRODUCT_TYPES.Oil.label
        : ALL_PRODUCT_TYPES.GasInlet.label)
  ) {
    return true;
  }
  return false;
};
